import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { API } from '../config/constants';

/**
 * Custom hook to track page visits.
 * Sends visit data to the backend on every page navigation.
 * Uses a session-based approach to avoid duplicate tracking.
 */
export const useVisitTracker = () => {
  const location = useLocation();
  const lastTrackedPath = useRef(null);
  const sessionId = useRef(null);

  useEffect(() => {
    // Generate session ID once per session
    if (!sessionId.current) {
      sessionId.current = sessionStorage.getItem('visit_session_id');
      if (!sessionId.current) {
        sessionId.current = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
        sessionStorage.setItem('visit_session_id', sessionId.current);
      }
    }

    // Only track if path changed (avoid tracking on re-renders)
    if (lastTrackedPath.current === location.pathname) {
      return;
    }
    lastTrackedPath.current = location.pathname;

    // Track the visit
    const trackVisit = async () => {
      try {
        await axios.post(`${API}/admin/track-visit`, {
          page: location.pathname,
          referrer: document.referrer || null,
          session_id: sessionId.current
        });
      } catch (error) {
        // Silently fail - visit tracking should not break the app
        console.debug('Visit tracking failed:', error.message);
      }
    };

    trackVisit();
  }, [location.pathname]);
};

export default useVisitTracker;
